import React from 'react'
import Sidebar from '../../../Components/Sidebar/Sidebar';
import { adminSideBarItems } from './Routes'

const Navbar = () => {
    return <Sidebar sideBarItems={adminSideBarItems} />
}

export default Navbar;